export default {"src":"/_next/static/media/logo-and-text-on-purple.0665af5c.svg","height":33,"width":167,"blurWidth":0,"blurHeight":0};